<template>
    <v-dialog v-model="showTable" scrollable
      max-width="600px">
      <v-card >
        <v-card-title>
          <v-row class="ma-0 pa-0">
            <v-spacer></v-spacer>
              <v-btn icon dark @click="showClose(false)">
                <v-icon color="primary">mdi-close</v-icon>
              </v-btn>
            <v-col class="pt-0 pb-0 text-center" cols="12">
              <h1 >{{title}}</h1>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row class="ma-0">
            <v-col class="py-0" cols="12">
              <p style="line-height: 23px; font-size: 16px;">
                Texto com aviso instruções específicas relacionadas a essa
                operadora. Como por exemplo: datas de transmissão de lotes ou
                qualquer outra informação instrutiva aos usuários do sistema.
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.
                Vitae proin sagittis nisl rhoncus mattis rhoncus urna neque.
                Consequat mauris nunc congue nisi vitae suscipit tellus mauris.
                Tellus cras adipiscing enim eu turpis. Sed felis eget velit
                aliquet sagittis id consectetur purus. Pharetra et ultrices
                neque ornare. Nunc mattis enim ut tellus elementum sagittis
                vitae. Sem fringilla ut morbi tincidunt augue interdum. Amet
                consectetur adipiscing elit duis. Euismod in pellentesque massa
                placerat duis ultricies lacus. In vitae turpis massa sed
                elementum tempus. Pharetra sit amet aliquam id diam maecenas
                ultricies. Sagittis orci a scelerisque purus semper eget. Ornare
                aenean euismod elementum nisi quis eleifend. Amet luctus
                venenatis lectus magna fringilla urna porttitor rhoncus.
                Pharetra pharetra massa massa ultricies mi. Purus in mollis nunc
                sed id semper risus in. Vulputate dignissim suspendisse in est
                ante in. Tellus molestie nunc non blandit massa enim nec. Diam
                in arcu cursus euismod quis viverra nibh cras pulvinar. Ipsum
                dolor sit amet consectetur adipiscing.
              </p>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

<v-btn
                width="20%"
                height="40px"
                color="primary"
                depressed
                class="px-5"
                @click="showClose"
              >
                Fechar
              </v-btn>
               <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      showTable: false,
    };
  },
  methods: {
  },
  watch: {
    tableInfo(val) {
      this.showTable = val;
    },
  },
  props: {
    tableInfo: Boolean,
    showClose: Function,
    title: String
  },
};
</script>

<style>
</style>